import React from "react";
import { FormFeedback } from "reactstrap";

const CustomFeedBack = ({ children }) => {
  return <FormFeedback style={{ display: "block" }}>{children}</FormFeedback>;
};

export default CustomFeedBack;
